import React from 'react';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { HeaderActionWrapper } from '@app/components/header/Header.styles';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { ReactComponent as QuestionIcon } from '@app/assets/icons/question.svg';
import styled from 'styled-components';

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  svg {
    margin-top: 8px;
    width: 100%;
    height: 100%;

    path {
      fill: var(--text-main-color);
      transition: fill 0.3s ease;
    }
  }
`;

const StyledButton = styled(BaseButton)`
  &:hover ${IconWrapper} {
    transform: scale(1.1);

    svg path {
      fill: var(--primary-color);
    }
  }
`;

export const FaqButton: React.FC = () => {
  const userState = useAppSelector((state) => state.user);
  const faqUrl = userState?.userData?.configuration?.faqUrl;
  const locale = useAppSelector((state) => state.locale.locale);

  if (!faqUrl) {
    return null;
  }

  const faqLink = faqUrl[locale];
  if (!faqLink) {
    return null;
  }

  const handleClick = () => {
    window.open(faqLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <HeaderActionWrapper>
      <StyledButton
        style={{ height: 40, width: 40 }}
        type="text"
        icon={
          <IconWrapper>
            <QuestionIcon />
          </IconWrapper>
        }
        onClick={handleClick}
      />
    </HeaderActionWrapper>
  );
};
